module.exports = require('./uiDelay')
